import React, { createElement, useEffect } from 'react'
import {
  Box,
  Button,
  Dialog,
  Divider,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core'
import { CLEAN_SUPER_QUESTION, PROPERTIES_BY_QUESTION_TYPE } from '../../utils'
import { useDispatch, useSelector } from 'react-redux'
import { setQuestion } from '../../features/State Management/questionSlice'
import TypeProperty from '../Atoms/Properties/TypeProperty'
import store from '../../store'
import { postprocessQuestion } from '../../utils/postprocessor'
import { UPDATE_QUESTION } from '../../features/State Management/questionsSlice'
import { SET_UTILITIES } from '../../features/State Management/utilitiesSlice'
import { useStyles } from '../Molecules/SaveQuestionnaireDialog'
import LocaleSelect from '../Atoms/LocaleSelect'

const EditDialog2 = ({ question, index, open, setOpen }) => {
  const dispatch = useDispatch()

  // load question to editor state on dialog open
  useEffect(() => {
    dispatch(setQuestion({ ...CLEAN_SUPER_QUESTION, ...question }))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = (event) => {
    event.preventDefault()
    const state = store.getState()
    const newQuestion = postprocessQuestion(state.question)
    dispatch(UPDATE_QUESTION({ id: question.id, new: newQuestion }))
  }

  // cancel all and return to Editor
  const handleClose = () => {
    // restore mappings
    dispatch(SET_UTILITIES(store.getState().utilities.saved))
    setOpen(false)
  }

  const classes = useStyles()

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth='md'>
      <form onSubmit={handleSubmit}>
        <Grid
          container
          direction='column'
          justifyContent='center'
          alignItems='stretch'
        >
          <DialogHeader className={classes.header} index={index} />
          <Box p={2.5}>
            <DialogBody />
          </Box>
          <DialogFooter
            handleClose={handleClose}
            question={question}
            index={index}
          />
        </Grid>
      </form>
    </Dialog>
  )
}

export default EditDialog2

const DialogHeader = ({ index, ...props }) => {
  const classes = useStyles()
  return (
    <div className={classes.stickyTop}>
      <Grid
        container
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        {...props}
      >
        <Grid item>
          <Typography variant='h6' style={{ userSelect: 'none' }}>{`Question ${
            index + 1
          }`}</Typography>
        </Grid>
        <Grid item>
          <LocaleSelect />
        </Grid>
        <Grid item>
          <TypeProperty />
        </Grid>
      </Grid>
      <Divider />
    </div>
  )
}

const DialogBody = () => {
  const type = useSelector((state) => state.question.type)
  const classes = useStyles()

  const PropertyGroup = ({ title, propertyGroupName }) => {
    return (
      <Paper variant='outlined' className={classes[title.toLowerCase()]}>
        <Typography variant='subtitle2' style={{ userSelect: 'none' }}>
          {title}
        </Typography>
        {PROPERTIES_BY_QUESTION_TYPE[type.toUpperCase()][propertyGroupName].map(
          (property) => (
            <Box key={property.name} className={classes.mtb} p={0}>
              {createElement(property)}
            </Box>
          )
        )}
      </Paper>
    )
  }

  return (
    <div className={classes.body}>
      <PropertyGroup title='Required' propertyGroupName='requiredProperties' />
      <PropertyGroup title='Optional' propertyGroupName='optionalProperties' />
    </div>
  )
}

const DialogFooter = ({ handleClose, index }) => {
  const classes = useStyles()

  return (
    <div className={classes.stickyBot}>
      <Divider />
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='center'
      >
        <Grid item xs>
          <Button
            disableElevation
            className={classes.button1}
            color='secondary'
            onClick={handleClose}
            data-cy={'cancel' + (index + 1)}
          >
            cancel
          </Button>
        </Grid>
        <Divider orientation='vertical' flexItem />
        <Grid item xs>
          <Button
            disableElevation
            className={classes.button2}
            type='submit'
            data-cy={'submit' + (index + 1)}
          >
            save
          </Button>
        </Grid>
      </Grid>
    </div>
  )
}
